(() => {
  'use strict';
  const ready = new WeakSet();
  function initialize(root = document) {
    root.querySelectorAll('[data-bundle-builder]').forEach(builder => {
      if (ready.has(builder)) return;
      ready.add(builder);
      const form = builder.querySelector('[data-bundle-form]');
      const selects = [...builder.querySelectorAll('[data-bundle-choice]')];
      const button = builder.querySelector('[data-bundle-add]');
      const status = builder.querySelector('[data-bundle-status]');
      const summary = builder.querySelector('[data-bundle-summary]');
      const total = builder.querySelector('[data-bundle-total]');
      const preview = builder.dataset.preview === 'true';
      let busy = false;
      let formatter;
      try { formatter = new Intl.NumberFormat(builder.dataset.locale || 'en', {style:'currency', currency:builder.dataset.currency || 'CAD'}); }
      catch { formatter = new Intl.NumberFormat('en', {style:'currency', currency:'CAD'}); }
      function validate() {
        if (!selects.length || selects.some(select => !select.value || select.selectedOptions[0].disabled)) return status.dataset.incomplete;
        for (const group of builder.querySelectorAll('[data-choice-group]')) {
          if (group.dataset.repeat === 'false') {
            const values = [...group.querySelectorAll('select')].map(select => select.value);
            if (new Set(values).size !== values.length) return status.dataset.duplicate;
          }
        }
        return '';
      }
      function update() {
        summary.replaceChildren();
        let amount = 0;
        for (const select of selects) {
          if (!select.value) continue;
          const option = select.selectedOptions[0];
          const item = document.createElement('li'); item.textContent = option.textContent;
          summary.append(item); amount += Number(option.dataset.price || 0);
        }
        total.textContent = preview ? 'Prices available in Shopify' : (summary.children.length ? formatter.format(amount / 100) : '—');
        const error = validate();
        status.textContent = error;
        button.disabled = busy || !!error;
      }
      form.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || validate() || !form.reportValidity()) return;
        if (preview) { status.textContent = 'Your choices are ready. This preview does not place items in a live Shopify bag.'; return; }
        busy = true; button.disabled = true; form.setAttribute('aria-busy','true');
        selects.forEach(select => { select.disabled = true; });
        status.textContent = status.dataset.adding;
        const quantities = new Map();
        selects.forEach(select => quantities.set(select.value, (quantities.get(select.value) || 0) + 1));
        const groupId = window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2);
        const items = [...quantities].map(([id,quantity]) => ({id,quantity,properties:{Bundle:builder.dataset.bundleName,_bundle_group:groupId}}));
        try {
          const response = await fetch(builder.dataset.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('Cart addition not confirmed');
          await response.json();
          status.textContent = status.dataset.success;
          window.location.assign(builder.dataset.cartUrl);
        } catch {
          // Do not automatically retry: a timeout or stock error may follow a partial addition.
          status.textContent = status.dataset.error;
          busy = false; selects.forEach(select => { select.disabled = false; });
          button.disabled = false;
        } finally { form.removeAttribute('aria-busy'); }
      });
      window.addEventListener('pageshow', event => {
        if (!event.persisted || !builder.isConnected) return;
        busy = false; selects.forEach(select => { select.disabled = false; }); update();
      });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
